'use strict';

import RouterStore from '../stores/RouterStore';
import AppDispatcher from '../AppDispatcher';
import ActionTypes from '../constants/ActionTypes';
import SidebarActionCreators from './SidebarActionCreators';
import AlertActionCreators from '../actions/AlertActionCreators';
import AlertTypes from '../constants/AlertTypes';
import NotificationActionCreators from '../actions/NotificationActionCreators';
import NotificationMessages from '../constants/NotificationMessages';
import parseStampSegment from '../utils/parseStampSegment';
import { replaceWith } from '../router';

const DraftServerActionCreators = {
  handleSaveDraft(err, response, previousDraftUuid) {
    const isNewDraft = !previousDraftUuid;
    let draftUuid;
    if (!err) {
      draftUuid = response.result;
    }

    AppDispatcher.handleServerAction({
      type: err ? ActionTypes.SAVE_DRAFT_ERROR : ActionTypes.SAVE_DRAFT_SUCCESS,
      response,
      draftUuid,
      isNewDraft
    });

    if (err) {
      console.error(err);
    } else if (isNewDraft) {
      const { params: { stampSegment } } = RouterStore.getRouterState();
      const { isNewDraft: isStillAtNewDraftRoute } = parseStampSegment(stampSegment);

      if (isStillAtNewDraftRoute) {
        replaceWith('draftCompose', { stampSegment: draftUuid });
      }
    }
  },

  handleLoadStampInEditor(err, response, stampId) {
    AppDispatcher.handleServerAction({
      type: err ? ActionTypes.LOAD_STAMP_IN_EDITOR_ERROR : ActionTypes.LOAD_STAMP_IN_EDITOR_SUCCESS,
      response: response,
      stampId: stampId
    });

    if (err) {
      console.log(err);
    }
  },

  handleLoadDraftInEditor(err, response, draftUuid) {
    AppDispatcher.handleServerAction({
      type: err ? ActionTypes.LOAD_DRAFT_IN_EDITOR_ERROR : ActionTypes.LOAD_DRAFT_IN_EDITOR_SUCCESS,
      response: response,
      draftUuid: draftUuid
    });

    if (err) {
      const { params: { stampSegment } } = RouterStore.getRouterState();

      if (err.status === 404 && stampSegment === draftUuid) {
        AlertActionCreators.showAlert(AlertTypes.NOT_FOUND, { hideOnRouteChange: false });
        replaceWith('feed');
      } else {
        console.error(err);
      }
    }
  },

  handleDeleteDraft(err, response, draftUuid) {
    AppDispatcher.handleServerAction({
      type: err ? ActionTypes.DELETE_DRAFT_ERROR : ActionTypes.DELETE_DRAFT_SUCCESS,
      response: response,
      draftUuid: draftUuid
    });

    if (err) {
      console.error(err);
    } else {
      replaceWith('draftCompose', { stampSegment: 'new' });
    }
  },

  handleSendFeedback(err, response, draftUuid) {
    AppDispatcher.handleServerFormAction({
      type: err ? ActionTypes.SEND_DRAFT_FEEDBACK_ERROR : ActionTypes.SEND_DRAFT_FEEDBACK_SUCCESS,
      response: response,
      err: err,
      draftUuid: draftUuid
    });

    if (err) {
      console.error(err);
    } else {
      SidebarActionCreators.hideSidebar();
      NotificationActionCreators.showNotification(NotificationMessages.DRAFT_FEEDBACK_SENT);
    }
  },

  handleDraftsPage(err, response) {
    AppDispatcher.handleServerAction({
      type: err ? ActionTypes.REQUEST_DRAFTS_ERROR : ActionTypes.REQUEST_DRAFTS_SUCCESS,
      response: response
    });

    if (err) {
      console.error(err);
    }
  },

  handleDraftFeedbacksPage(err, response, draftUuid) {
    AppDispatcher.handleServerAction({
      type: err ? ActionTypes.REQUEST_DRAFT_FEEDBACKS_ERROR : ActionTypes.REQUEST_DRAFT_FEEDBACKS_SUCCESS,
      response: response,
      draftUuid: draftUuid
    });

    if (err) {
      console.error(err);
    }
  }
};

export default DraftServerActionCreators;


/** WEBPACK FOOTER **
 ** ./actions/DraftServerActionCreators.js
 **/